import { render, staticRenderFns } from "./VersionEntry.vue?vue&type=template&id=0f9cbaf7"
import script from "./VersionEntry.vue?vue&type=script&lang=ts"
export * from "./VersionEntry.vue?vue&type=script&lang=ts"
import style0 from "./VersionEntry.vue?vue&type=style&index=0&id=0f9cbaf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports